import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=c672802c&scoped=true"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserStatistics.vue?vue&type=style&index=0&id=c672802c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c672802c",
  null
  
)

export default component.exports